import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { detectBrowser, isExtensionAvailableForBrowser } from '../utils/browserDetection';
import './ExtensionComingSoonBanner.css';

const STORAGE_KEY = 'kairos-extension-coming-soon-banner-dismissed';

export const ExtensionComingSoonBanner: React.FC = () => {
  const location = useLocation();
  const [isDismissed, setIsDismissed] = useState(false);
  const [extensionAvailableForBrowser, setExtensionAvailableForBrowser] = useState<boolean | null>(null);

  const isLoginPage = location.pathname === '/' || location.pathname === '/login';

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (dismissed === 'true') {
      setIsDismissed(true);
    }
  }, []);

  useEffect(() => {
    const info = detectBrowser();
    setExtensionAvailableForBrowser(isExtensionAvailableForBrowser(info.type));
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem(STORAGE_KEY, 'true');
  };

  // Only show "coming soon" when extension is NOT available for this browser (Edge, Firefox, Safari, unknown)
  const shouldShow =
    extensionAvailableForBrowser === false &&
    !(isLoginPage || isDismissed);

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="extension-coming-soon-banner" role="status" aria-live="polite">
      <div className="extension-coming-soon-banner__content">
        <div className="extension-coming-soon-banner__icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2L2 7L12 12L22 7L12 2Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 17L12 22L22 17"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="extension-coming-soon-banner__text">
          <div className="extension-coming-soon-banner__title">
            Browser extension coming soon
          </div>
          <div className="extension-coming-soon-banner__description">
            A Kairos browser extension will be available shortly. Until then, you can add jobs by creating a new application on the Applications screen (manual copy and paste of job URL and description), or use Intelligent Search from the Job Search menu (15 tokens) for a streamlined workflow.
          </div>
        </div>
        <button
          type="button"
          onClick={handleDismiss}
          className="extension-coming-soon-banner__dismiss"
          aria-label="Dismiss banner"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
